import { loginUser } from "../interfaces/static.interface";

export const InitialBaseState: loginUser = {
    success: false,
    userData: null,
    statusCode: null,
}